module.exports = __webpack_public_path__ + "static/media/logo-comune-belpasso.c98253a9.png";